import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Contact</h3>
            <div className="footer-contact">
              <div className="contact-item">
                <span className="contact-label">Email:</span>
                <a href="mailto:alicia@counselingwellbeing.net" className="contact-link">
                  alicia@counselingwellbeing.net
                </a>
              </div>
              <div className="contact-item">
                <span className="contact-label">Phone:</span>
                <a href="tel:5126886372" className="contact-link">
                  512.688.6372
                </a>
              </div>
            </div>
          </div>
          <div className="footer-section">
            <p className="footer-location">Austin, Texas 78757</p>
            <p className="footer-note">Virtual sessions available throughout Texas</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Alicia Gostylo Counseling. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


